import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { Demo } from '~/components/settings/Demo';

import { routeParams } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/admin/demo/')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/admin/demo',
    ...routeParams,
  }),

  component: Demo,
});

export const ADMIN_DEMO = buildRouteExport({
  Route,
  ...routeParams,
});
